<template>
  <div>
    <app-cells>
      <h1 class="title">Fast track list</h1>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'CalculatorLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'fast-track-upcoming', label: 'Upcoming' },
        { name: 'fast-track-archive', label: 'Archive' },
      ]
    }
  },
}
</script>
